<template>
	<div class="tab-text">
		<section>
			<h1 class="py-5">Check In</h1>
			<div class="vx-row mb-6">
				<div class="vx-col sm:w-1/3 w-full">
					<span>Check In Type</span>
					<div style="font-size:0.75rem; color:#aaa;">
						Choose the type of check in for your event
					</div>
				</div>
				<div class="vx-col sm:w-2/3 w-full">
					<b-form-select style="max-width: 240px;" :options="checkInTypeList"
						v-model="checkInTypeSelected"></b-form-select>
				</div>
			</div>
			<div class="vx-row mb-6">
				<div class="vx-col sm:w-1/3 w-full">
					<span>Multiple Days</span>
					<div style="font-size:0.75rem; color:#aaa;">
						Choose for event that have multiple days
					</div>
				</div>
				<div class="vx-col sm:w-2/3 w-full">
					<ul class="demo-alignment">
						<li>
							<vs-radio vs-name="radios-multi-day" v-model="multiDaySelected" vs-value="1">Yes</vs-radio>
						</li>
						<li>
							<vs-radio vs-name="radios-multi-day" v-model="multiDaySelected" vs-value="0">No</vs-radio>
						</li>
					</ul>
				</div>
			</div>
			<div class="vx-row mb-6">
				<div class="vx-col sm:w-1/3 w-full">
					<span>Multi-Sessions Per Day</span>
					<div style="font-size:0.75rem; color:#aaa;">
						Choose for event that have multi-sessions per day
					</div>
				</div>
				<div class="vx-col sm:w-2/3 w-full">
					<ul class="demo-alignment">
						<li>
							<vs-radio vs-name="radios-multi-per-day" v-model="multiPerDaySelected"
								vs-value="1">Yes</vs-radio>
						</li>
						<li>
							<vs-radio vs-name="radios-multi-per-day" v-model="multiPerDaySelected"
								vs-value="0">No</vs-radio>
						</li>
					</ul>
				</div>
			</div>
			<div class="vx-row mb-6">
				<div class="vx-col sm:w-1/3 w-full">
					<span>Check Out</span>
					<div style="font-size:0.75rem; color:#aaa;">
						Choose for event that have check out
					</div>
				</div>
				<div class="vx-col sm:w-2/3 w-full">
					<ul class="demo-alignment">
						<li>
							<vs-radio vs-name="radios-check-out" v-model="checkOutSelected" vs-value="1">Yes</vs-radio>
						</li>
						<li>
							<vs-radio vs-name="radios-check-out" v-model="checkOutSelected" vs-value="0">No</vs-radio>
						</li>
					</ul>
				</div>
			</div>
			<vs-divider></vs-divider>
			<div class="vx-row pt-2 mt-0">
				<div class="vx-col w-full ml-auto">
					<vs-button class="mr-3 mb-2" color="primary" type="filled" @click="onSavePressed()">Save</vs-button>
					<vs-button class="mr-3 mb-2" type="border" @click="onCancelPressed()">Cancel </vs-button>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import Service from "@/services";

export default {
	props: {
		event: null,
	},
	data() {
		return {
			roleValidated: false,
			rolePopup: false,
			checkInTypeSelected: this.event.checkin_type,
			checkInTypeList: [
				{ text: "Check In Only", value: "checkin_only" },
				{ text: "Check In and Print Badge", value: "checkin_print_badge" },
				{ text: "Check-in and Receive Wristband", value: "checkin_wristband" },
				{ text: "Check-in and Receive RFID Wristband", value: "checkin_wristband_rfid" },
			],
			multiDaySelected: this.event.multi_per_day,
			multiPerDaySelected: this.event.multiday,
			checkOutSelected: this.event.check_out,
			roleList: [],
			roleColumns: [
				{ label: "ID", key: "slug", sortable: false },
				{ label: "Name", key: "name", sortable: false },
				{ label: "Color", key: "color", sortable: false },
				{ label: "Remark", key: "remark", sortable: false },
				{ label: "Listing Status", key: "listing_status", sortable: false },
				{ label: "Checkin Type", key: "checkin_type", sortable: false },
				{ label: "Action", key: "action", sortable: false }
			],
			colorList: [
				{ text: "BLACK", value: "#000000" },
				{ text: "WHITE", value: "#FFFFFF" },
				{ text: "GOLD", value: "#ffd700" },
				{ text: "SILVER", value: "#c0c0c0" },
				{ text: "GREEN", value: "#008000" },
				{ text: "LIGHT GREEN", value: "#00FF00" },
				{ text: "BLUE", value: "#0000FF" },
				{ text: "LIGHT BLUE", value: "#87ceeb" },
				{ text: "AQUA", value: "#00FFFF" },
				{ text: "ORANGE", value: "#ffa500" },
				{ text: "PURPLE", value: "#800080" },
				{ text: "YELLOW", value: "#FFFF00" },
				{ text: "RED", value: "#FF0000" },
				{ text: "PINK", value: "#ff69b4" },
			],
			createRoleForm: {
				name: null,
				slug: null,
				color: null,
				color_code: null,
				remark: null,
				listing_status: 1,
				checkin_type: null,
			}
		};
	},
	watch: {
		'$data.rolePopup': {
			handler: function (state) {
				this.$validator.reset();
				if (!state) {
					this.createRoleForm = {
						name: null,
						slug: null,
						color: null,
						color_code: null,
						remark: null,
						listing_status: 1,
						checkin_type: null,
					}
				}
			},
		}
	},
	created() {
		const jsonRole = JSON.parse(this.event.ticket_role);
		const roles = Object.keys(jsonRole).map((key) => jsonRole[key]);
		this.roleList = roles;
	},
	methods: {
		async onSavePressed() {
			const roleObject = {};
			this.roleList.forEach((role) => {
				if (role.edit) delete role.edit;
				role.listing_status = parseInt(role.listing_status);
				roleObject[role.slug] = role;
			});

			const data = {
				checkin_type: this.checkInTypeSelected,
				checkin_multi_day: parseInt(this.multiDaySelected),
				checkin_multi_per_day: parseInt(this.multiPerDaySelected),
				check_out: parseInt(this.checkOutSelected),
			}

			try {
				this.$vs.loading();
				const res = await Service.Event.updateEventDay(data, this.event.e)
				if (res.success) {
					this.$emit("loadEvent");
					this.$vs.notify({
						color: 'success',
						title: 'Complete',
						text: 'Edit check-in success',
					})
				}
			} catch (error) {
				this.$vs.notify({
					title: "Oops!",
					text: "ERROR : " + error.error,
					color: "danger"
				});
			} finally {
				this.$vs.loading.close();
			}
		},
		onCancelPressed() {
			this.$router.push(`/dash`)
		},
	}
};
</script>

<style lang="scss" scoped>
.remark-textarea {
	margin-bottom: unset !important;
}

.grid-button-upload {
	.grid-button-upload {
		.grid-button-upload {
			margin-top: 8px;
			display: grid;
			grid-template-columns: repeat(2, min-content);
			grid-gap: 10px;
		}

		.vs-button {
			font-size: 10px !important;
		}

		input[type="file"] {
			display: none !important;
		}

		.popup-confirm {
			& div {
				width: 100%;
				text-align: center;
			}

			& .wrap-button {
				display: grid;
				grid-template-columns: repeat(2, 25%);
				grid-gap: 8px;
				justify-content: flex-end;
				margin-top: 20px;

			}
		}
	}
}
</style>